import React, { useState, useEffect } from 'react';

const timeout = 10*1000;
let timeId = 0;
const Loader = function (props) {
    const [loadingTimeout, setLoadingTimeout] = useState(timeout), data = props.data ? props.data : null;
    let loaderMessage = "Chargement...", timeoutMessage = "La réponse est lente, vérifiez la disponibilité du serveur !";
    if(data){
        if(data.loaderMessage){
            loaderMessage = data.loaderMessage;
        }
        if(data.timeoutMessage){
            timeoutMessage = data.timeoutMessage;
        }
    }

    let element = (
        <div id="loading" className="loading-center">
            <div className="loading-center-absolute">
                <div className="object"></div>
                <div className="object"></div>
                <div className="object"></div>
                <div className="object"></div>
                <div className="object"></div>
                <div className="object"></div>
                <div className="object"></div>
                <div className="object"></div>
                <div className="object"></div>
                <div className="object"></div>
            </div>
            <p>{loaderMessage}</p>
        </div>
    );
    useEffect(() => {
        if(loadingTimeout === timeout){
            timeId = setTimeout(() => {
                if(data && data.onPageLoaderTimeout){
                    data.onPageLoaderTimeout(true);
                }
                setLoadingTimeout(0);
            }, timeout);
        }
        return () => {clearTimeout(timeId);}
    }, [loadingTimeout, data]);

    if(loadingTimeout === 0){
        clearTimeout(timeId);
        element = (<h1>{timeoutMessage}</h1>);
    }
    return (
        <div className="loading-page" style={{textAlign: "center"}}>
            {element}
        </div>
    );
}

export default Loader;